import styled from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  background-color: #fff;
  border: none;
  flex-flow: row nowrap;
  height: 3.125rem;
  justify-content: center;
  margin: 0.6rem 0;
  outline: none;
  position: relative;

  width: ${({ width }) => (width ? '100%' : '85%')};

  display: ${({ clicked }) => (clicked ? 'flex' : 'none')};

  @media (min-width: 36rem) {
    width: ${({ width }) => (width ? '100%' : '31.25rem')};
  }

  @media (min-width: 48rem) {
    width: ${({ width }) => (width ? '100%' : '42.5rem')};
  }

  @media (min-width: 62rem) {
    display: flex;
    margin: 0 10px;
    width: ${({ width }) => (width ? '100%' : '230px')};
  }
`;

export const BackgroundClick = styled.button`
  background-color: transparent;
  cursor: pointer;
  height: 100%;
  left: 0;
  opacity: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 5;

  display: ${({ toggle, displayMenu }) => (toggle && displayMenu ? 'block' : 'none')};

  @media (min-width: 62rem) {
    display: ${({ toggle }) => (toggle ? 'flex' : 'none')};
  }
`;

export const Select = styled.button`
  align-items: center;
  background-color: transparent;
  border: none;
  display: flex;
  flex-flow: row nowrap;
  height: 100%;
  justify-content: space-between;
  outline: none;
  padding: 0 1.5rem;
  width: 100%;

  &:hover {
    cursor: pointer;
  }
`;

export const Label = styled.span`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'GESSTwoDWTCLight,sans-serif' : 'DINRegular')};
  color: #999;
  font-size: 0.65rem;
  letter-spacing: ${({ dir }) => (dir === 'rtl' ? '' : '0.07rem')};
  text-transform: uppercase;
`;

export const Arrow = styled.div`
  height: 1.8rem;
  margin: 0 0.5rem;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: auto;
  right: ${({ dir }) => (dir === 'rtl' ? '' : '0.5rem')};
  left: ${({ dir }) => (dir === 'rtl' ? '0.5rem' : '')};
  &[dir='ltr'] {
    right: 0.5rem;
  }

  &[dir='rtl'] {
    left: 0.5rem;
  }

  svg {
    height: 2rem;
    width: 20px;
  }
`;

export const Container = styled.div`
  align-items: flex-start;
  background-color: #fff;
  border-radius: 0.25rem;
  border: 1px solid #d8d8d8;
  flex-flow: column nowrap;
  justify-content: flex-start;
  left: 0;
  min-width: 230px;
  max-height: 16rem;
  overflow-y: auto;
  padding: 0.6rem 0;
  position: absolute;
  top: -2px;
  ${({ topOverflow }) =>
    topOverflow ? 'transform: translate(0px, 55px);' : 'transform: translate(0px, -100%);'}
  width: auto;
  z-index: 10;

  display: ${({ toggle, displayMenu }) => (toggle && displayMenu ? 'flex' : 'none')};

  @media (min-width: 62rem) {
    display: ${({ toggle }) => (toggle ? 'flex' : 'none')};
    width: fit-content;
  }
`;

export const Option = styled.span`
  width: 100%;
  font-size: 0.8rem;
  font-family: inherit;
  margin: 0.5rem 0;
  padding: 0.3rem 1.5rem;
  transition: all 700ms;
  white-space: nowrap;

  ${({ selected }) => (selected ? 'background-color: #1b7bdd; color: #fff' : 'color: #212529')};

  &:hover {
    background-color: #f2f2f2;
    color: #1b7bdd;
    cursor: pointer;
  }
`;
